import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  spaceId: number;
};

// We should consider merging this for shared and owned kits.
const [useRemoveSharedKit, removeSharedKit] = createAsyncAction(
  "kits/removeShared",
  async (args: Args) => {
    const res = await API.call<{ kit: string }>({
      endpoint: `kits/${args.spaceId}/${args.kitId}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.kit };
  }
);

export default useRemoveSharedKit;
export { removeSharedKit };
